import IconWithBackground from '../IconWithBackground/IconWithBackground'
import { OrderLine, Product, ProductOption } from '../../model'
import styles from './ProductQuoteItem.module.scss'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface ProductQuoteItemProps {
    product: any
    showHighlight?: boolean
    showOptions?: boolean
    productInBasket?: undefined | Product
    disabled?: boolean
    size?: 'small'
    removeProductFromBasket?: (product: any) => void
    addProductToBasket?: (product: any) => void
}

const ProductQuoteItem: React.FC<ProductQuoteItemProps> = ({
    product,
    showHighlight = true,
    showOptions = true,
    productInBasket,
    disabled = false,
    size = undefined,
    removeProductFromBasket,
    addProductToBasket
}) => {
    const selectedProductOptions: ProductOption[] | OrderLine[] | undefined | false =
        product.options ||
        (productInBasket &&
            productInBasket.availableOptions &&
            productInBasket.availableOptions.length > 0 &&
            productInBasket?.availableOptions.filter((availableOption: any) => availableOption._isAdded))

    const handleClick = () => {
        if (productInBasket && removeProductFromBasket) {
            removeProductFromBasket(product)
        } else if (addProductToBasket) {
            addProductToBasket(product)
        }
    }

    return (
        <div
            onClick={disabled ? undefined : handleClick}
            className={
                styles.productQuoteItem +
                ` ${
                    productInBasket && showHighlight ? 'bg-opacity-10' : 'bg-opacity-0'
                } px-4 border-btm last:border-b-0 justify-between items-center ${size === 'small' ? 'py-1' : 'py-3'} ${
                    disabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer hover:bg-opacity-5'
                }`
            }
        >
            <div className='flex items-center'>
                <IconWithBackground size={size} iconName={product?.icon || 'geen'} />
                <div className='ml-4'>
                    <h2 className={'text-base mb-0 ' + (size === 'small' ? ' text-sm' : '')}>{product.name}</h2>
                    {product.description && (
                        <span
                            className='text-xs text-gray-500'
                            dangerouslySetInnerHTML={{ __html: product.description }}
                        ></span>
                    )}
                    {showOptions &&
                        selectedProductOptions &&
                        selectedProductOptions?.map((availableOption: any, i: number) => {
                            return (
                                <div key={i} className='text-xs text-gray-500'>
                                    <span>+ {availableOption.name}</span>
                                </div>
                            )
                        })}
                    {disabled && (
                        <div className='text-xs text-[--tb-primary]'>
                            <span>Al geselecteerd</span>
                        </div>
                    )}
                </div>
            </div>
            <div className='space-x-4 flex items-center'>
                <DynamicFaIcon
                    iconName={productInBasket ? 'check-circle' : 'circle-arrow-right'}
                    className='text-[#2EB5AD] text-3xl'
                />
            </div>
        </div>
    )
}

export default ProductQuoteItem
